<template>
	<div style="width: 98%; height: 64%; padding: 0">
		<div class="relativeContainer percent100">
			<div class="planDate">
				计划时间:{{ a.planDate }}-{{ a.ctTime == 0 ? "上午" : "下午" }}
			</div>
			<!-- 地图部分 -->
			<div class="search" v-if="placeSearch">
				<!-- <button type="button" class="outBtn" @click="backPlans">刷新</button> -->
				<el-button size="small" type="primary" @click="backPlans" plain>刷新</el-button>
				<el-button size="small" type="primary" @click="lableClick()" plain>{{lableShow==false?'标签显示':'标签隐藏'}}
				</el-button>
			</div>

			<div id="js-container" class="map">正在加载数据 ...</div>

			<!-- 车辆选择表单 -->
			<el-dialog title="路线执行车辆" width="600px" v-show="dialogVisible" :modal-append-to-body="false"
				:visible.sync="dialogVisible" :before-close="handleClose" :close-on-click-modal="false"
				:close-on-press-escape="false">
				<div class="vForm">
					<p>路线执行车辆</p>
					<el-select v-model="numberPlateIndex" style="width: 300px" clearable placeholder="请选择路线执行车辆">
						<el-option v-for="(item, index) in vehicleList" :key="item.value"
							:label="item.numberPlate + ' -- 车载量:' + item.weight + 'Kg'" :value="index"></el-option>
					</el-select>
				</div>
				<div class="vFormTow">
					<el-button type="primary" @click="Submit()">确定</el-button>
					<el-button @click="cancel()">取消</el-button>
				</div>
			</el-dialog>
		</div>
		<!-- 编辑左侧栏 -->
		<div v-if="divShow" class="divShow">
			<!-- 搜索部分 -->
			<div class="searchInput">
				<el-input class="inputData" @input="handleSearch" placeholder="请输入关键字" v-model="inputData" clearable>
				</el-input>
				<div class="divDate" v-if="freePoints.length == 0 ? false : true">
					<div v-for="(item, index) in freePoints" :key="index">
						<p :title="
                '名称:' +
                item.unitName +
                '[' +
                (item.weight ? item.weight : 0) +
                'kg]'
              ">
							{{ item.unitName + "[" + (item.weight ? item.weight : 0) }} kg]
						</p>
						<i class="el-icon-plus" @click="searchClick(index)"></i>
					</div>
				</div>
			</div>
			<!-- 编辑展示部分 -->
			<h1>
				<em @click="backPlans()" class="el-icon-back"></em>
				{{ numberPlate }}
				<i @click="refreshTow()" class="el-icon-edit"></i>
			</h1>
			<h2>
				<span>{{ a.planDate }}-{{ a.ctTime == 0 ? "上午" : "下午" }}</span>
				<span>
					预产量:
					<i>{{ weight ? weight : 0 }}</i> Kg
				</span>
			</h2>
			<hr />
			<div v-loading="fullscreenLoading" class="editDiv">
				<div v-for="(item, index) in planData.linePiece.routePoints" :key="index">
					<span v-if="index == 0 || index == planData.linePiece.routePoints.length - 1">{{ index + 1 }}</span>
					<span v-else @dblclick="edit" style="cursor:pointer;" ref="element">{{ index + 1 }}</span>
					<!-- <el-input size="small" v-model="formNum" @change="gotodata(index,formNum)" style="width: 50px;"></el-input> -->
					<em :title="
              index == 0 || index == planData.linePiece.routePoints.length - 1
                ? item.unitName
                : item.unitName +
                  ' [' +
                  (item.weight ? item.weight : 0) +
                  ' kg' +
                  ']'
            ">{{
              index == 0 || index == planData.linePiece.routePoints.length - 1
                ? item.unitName
                : item.unitName +
                  " [" +
                  (item.weight ? item.weight : 0) +
                  " kg" +
                  "]"
            }}</em>
					<p>
						<!--  v-if="index==planData.linePiece.routePoints.length-1?false:true" -->
						<el-radio style="margin-right: 5px" v-model="radio" @change="plan1AddPoint(index)"
							type="primary" :loading="radio == index ? true : false" :label="index">
							{{ item.newlyAdded == 1 ? "新增" + index : "" }}
						</el-radio>
						<i v-if="
                index == planData.linePiece.routePoints.length - 1 || index == 0
                  ? false
                  : true
              " @click="plan1DelPoint(index)" style="color: #ff4f4f" class="el-icon-delete-solid"></i>
					</p>
				</div>
			</div>
			<el-button class="btn" type="primary" @click="plan1save()">提交</el-button>
		</div>
		<!-- 终点选择表单 -->
		<el-dialog title="新增计划终点选择" width="500px" v-show="startEndPointShow" :showClose="false"
			:modal-append-to-body="false" :visible.sync="startEndPointShow" :close-on-click-modal="false"
			:close-on-press-escape="false">
			<el-form :model="startEndForm" label-position="left" size="small" ref="startEndForm" class="demo-ruleForm"
				:rules="rules">
				<!-- :before-close="handlestartEnd" -->
				<el-form-item label="新增计划终点" prop="startEndIndex" label-width="150px">
					<el-select v-model="startEndForm.startEndIndex" style="width: 300px" clearable
						placeholder="请选择计划终点">
						<el-option v-for="(item, index) in EndPoint" :key="item.value" :label="item.huName"
							:value="index"></el-option>
					</el-select>
				</el-form-item>
			</el-form>
			<div class="vFormTow">
				<el-button type="primary" @click="startEndSubmit('startEndForm')">确定</el-button>
				<el-button type="primary" @click="studyMakeMoney()">取消</el-button>
			</div>
		</el-dialog>
		<div class="iconFrom" @click="collectShow = !collectShow" v-show="!collectShow">
			<i class="iconfont iconche" style="font-size: 18px"></i>工作台
			<i class="iconfont iconxiangshang"></i>
		</div>
		<div class="iconFromDiv" v-show="!collectShow"></div>
		<!-- 底部收运量 -->
		<transition name="collectShow">
			<div class="collect" v-show="collectShow">
				<div class="btn" @click="collectShow = !collectShow">
					<i class="iconfont iconche" style="font-size: 18px"></i>工作台
					<i class="iconfont iconzhankai"></i>
				</div>
				<!-- 数据表格 -->
				<el-table :data="tableData" border style="width: 100%;cursor:pointer;" height="300px" row-key="id"
					@row-click="handleCurrentChange" :row-class-name="tableRowClassName">
					<el-table-column width="50" align="center">
						<template slot-scope="scope">
							<span v-if="scope.row.carInfo.numberPlate">{{scope.row.index + 1}}</span>
						</template>
					</el-table-column>
					<!-- <el-table-column prop="startPoint.name" label="处理单位" align="center"></el-table-column> -->
					<el-table-column label="车牌号" align="center">
						<template slot-scope="scope">
							<span v-if="scope.row.carInfo.numberPlate">{{scope.row.carInfo.numberPlate}}</span>
						</template>
					</el-table-column>
					<el-table-column label="计划收运点位" align="center">
						<template slot-scope="scope">
							<span v-if="scope.row.carInfo.numberPlate">{{scope.row.unitCount}}</span>
						</template>
					</el-table-column>
					<el-table-column label="操作" align="center">
						<template slot-scope="scope">
							<el-button type="danger" size="mini" @click="deleteData(scope.row)" v-if="scope.row.carInfo.numberPlate">删除</el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>
		</transition>
	</div>
</template>
<script>
let MapKey = "ce585012e3b52ca6706d51aa7e06aaac";
let MapCityName = "深圳";
import remoteLoad from "@/components/map/lib/remoteLoad.js";
import planLine from "@/components/map/lib/planLine.js";

	export default {
		name: "home",
		props: ["a"],
		data() {
			return {
				searchKey: "",
				placeSearch: true,
				dragStatus: false,
				AMapUI: null,
				AMap: null,
				map: null,
				// 路线总
				plans: [],
				// 计划暂存
				plans2: [],
				// 数据请求的计划
				syList: [],
				// 设置的随机颜色
				varcolor: "",
				lxindex: "",
				// 路线对应原数据
				syListTow: "",
				// 用来存储当前编辑线路
				planData: "",
				// 存贮当前线路下标
				indexDate: "",
				// 左侧显示
				divShow: false,
				// 计划垃圾产量
				weight: 0,
				// 存储当前点位
				addPoint: "",
				// 用于存贮当前下标
				radio: "",
				// 待选车辆存储
				vehicleList: "",
				// 路线车辆选择表单
				dialogVisible: false,
				// 路线车辆名称
				numberPlate: "",
				// 当前执行车辆下标
				numberPlateIndex: "",
				// 加载中
				fullscreenLoading: false,
				// 搜索框数组
				inputData: "",
				// 搜索数据存储
				freePoints: "",
				// 计划起终点存储
				startEndPoint: [],
				// 特殊情况终点列表
				EndPoint: [],
				// 终点选择显隐
				startEndPointShow: false,
				// 终点下标
				startEndIndex: "",
				// 待选点存储
				freePointsList: [],
				// 新增数据保存
				syListData: [],
				// 重点表单
				startEndForm: {
					startEndIndex: "",
				},
				// 终点选择验证
				rules: {
					startEndIndex: [{
						required: true,
						message: "请选择终点",
						trigger: "blur"
					}, ],
				},
				// 选后的车辆
				vehicle: "",
				MarkerCluster: "", //点聚合相关
				cluster: "", //点聚合
				routeMode: "",
				carFlag: "", // 车辆新增状态
				carFlagId: "",
				collectShow: false,
				tableData: [],
				formNum: "",

				// 控制显示
				lableShow: true,
				mapData:"",
				mapDataCenter:"",
				mapDataZoom:"",
			};
		},
		mounted() {
			var that = this;

			// 将方法引入到全局中
			window["plan1Edit"] = (index) => {
				that.plan1Edit(index);
			};
			window["plan1AddPoint"] = (index) => {
				that.plan1AddPoint(index);
			};
			window["plan1AddPointTow"] = (index) => {
				that.plan1AddPointTow(index);
			};
			window["refFreePoints"] = (index) => {
				that.refFreePoints(index);
			};
			window["messageError"] = (data) => {
				that.messageError(data);
			};
			// 点击待选点进入新增状态
			window["refStartEnd"] = (data) => {
				that.refStartEnd(data);
			};
			// 放入点聚合中
			window["unitFormMap"] = (marker) => {
				that.unitFormMap(marker);
			};
			// 点聚合删除
			window["unitD"] = (marker) => {
				that.unitD(marker);
			};
		},
		async created() {
			window.$lableShow = true;
			// 载入高德地图和UI组件
			Promise.all([]).then(() => {
				this.initMap();
				setTimeout(() => {
					this.refFreePoints();
				}, 1000);
			});
		},
		methods: {
			lableClick() {
				$lableShow = !$lableShow;
				this.lableShow = $lableShow;
				this.mapDataCenter = this.mapData.getCenter();
				this.mapDataZoom = this.mapData.getZoom(); //获取当前地图级别
				this.backPlans();
			},
			studyMakeMoney() {
				this.$emit("emitMethods");
			},
			// 搜索
			handleSearch() {
				if (this.inputData) {
					this.freePoints = this.planData.linePiece.freePoints.filter((item) => {
						if (item.unitName.indexOf(this.inputData) != -1) {
							return item;
						}
					});
				} else {
					this.freePoints = "";
				}
			},
			// 地图初始化
			initMap(data) {
				let that = this;
				var mapCenter = "";
				var mapZoom = 14;

				if(this.mapDataCenter && this.mapDataZoom){
					mapCenter = this.mapDataCenter;
					mapZoom = this.mapDataZoom;
				}else{
					mapCenter = JSON.parse(localStorage.getItem("tr_tr_user"));
					mapCenter = [mapCenter.longitude, mapCenter.latitude];
				}

				// 加载PositionPicker，loadUI的路径参数为模块名中 'ui/' 之后的部分
				let AMapUI = (this.AMapUI = window.AMapUI);
				let AMap = (this.AMap = window.AMap);
				let mapConfig = {
					esizeEnable: true,
					zoom: mapZoom,
					// center: [118.965035, 42.277352]
					center: mapCenter,
				};
				let map = (this.map = new AMap.Map("js-container", mapConfig));
				// 启用工具条
				var gridSize = 60;
				var geolocation;
				this.MarkerCluster = AMap.plugin(
					[
						"AMap.ToolBar",
						"AMap.Geocoder",
						"AMap.Geolocation",
						"AMap.MarkerClusterer",
					],
					function() {
						map.addControl(
							new AMap.ToolBar({
								position: "RB",
							})
						);
						that.cluster = new AMap.MarkerClusterer(
							map, // 地图实例
							{
								gridSize: gridSize, // 设置网格像素大小
								renderClusterMarker: that._renderCluserMarker, // 自定义聚合点样式
								renderMarker: that._renderMarker, // 自定义非聚合点样式
							}
						);
						// 设置点聚合缩放等级
						that.cluster.setMaxZoom(14);
						// 自动中心定位部分
						var geocoder = new AMap.Geocoder({
							map: map,
							radius: 1000, //范围，默认：500
						});
					}
				);

				var plans3 = [];
				if (data == 1) {
					if (this.syList.length != 0) {
						// 随机颜色
						this.getRandomColor();
						if (this.syList[this.syList.length - 1].planUnitList) {
							plans3[0] = new planLine({
								AMap: AMap,
								map: map,
								baseColor: that.varcolor,
							});
							plans3[0].setData({
									routePoints: this.syList[this.syList.length - 1].planUnitList,
									freePoints: this.syList[this.syList.length - 1].unassignedUnitList,
									route: {
										pathPoint: this.syList[this.syList.length - 1].pathPoints,
										pathArray: [],
										path: undefined,
									},
								},
								this.syList.length - 1
							);
						}
					}
					this.plans2.push(plans3[0]);
					this.plans = this.plans2;
				}
        else {
					var plans2 = [];
					if (this.syList.length != 0) {
						this.syList.forEach((item, index) => {
							// 随机颜色
							this.getRandomColor();
							if (item.planUnitList) {
								plans2[index] = new planLine({
									AMap: AMap,
									map: map,
									baseColor: that.varcolor,
								});
								plans2[index].setData({
										routePoints: item.planUnitList,
										freePoints: item.unassignedUnitList,
										route: {
											pathPoint: item.pathPoints,
											pathArray: [],
											path: undefined,
										},
									},
									index
								);
							}
						});
					}
					this.plans2 = plans2;
					this.plans = plans2;
				}
				this.stopsShow = true;
				if (data == 1) {
					// this.plan1Edit(this.plans.length - 1);
					this.plan1Edit(this.plans.length - 1, this.syList.length - 1);
				}
				this.mapData = map;
			},
			// 放入点聚合
			unitFormMap(marker) {
				this.cluster.addMarker(marker);
			},
			// 点聚合删除
			unitD(marker) {
				this.cluster.removeMarker(marker);
			},
			// 点聚合
			_renderCluserMarker(context) {
				const count = this.markers.length;
				let factor = Math.pow(context.count / count, 1 / 18);
				let div = document.createElement("div");
				let Hue = 180 - factor * 180;
				let bgColor = "hsla(" + Hue + ",100%,50%,0.7)";
				let fontColor = "hsla(" + Hue + ",100%,20%,1)";
				let borderColor = "hsla(" + Hue + ",100%,40%,1)";
				let shadowColor = "hsla(" + Hue + ",100%,50%,1)";
				div.style.backgroundColor = bgColor;
				let size = Math.round(30 + Math.pow(context.count / count, 1 / 5) * 20);
				div.style.width = div.style.height = size + "px";
				div.style.border = "solid 1px " + borderColor;
				div.style.borderRadius = size / 2 + "px";
				div.style.boxShadow = "0 0 1px " + shadowColor;
				div.innerHTML = context.count;
				div.style.lineHeight = size + "px";
				div.style.color = fontColor;
				div.style.fontSize = "14px";
				div.style.textAlign = "center";
				context.marker.setOffset(new AMap.Pixel(-size / 2, -size / 2));
				context.marker.setContent(div);
			},
			_renderMarker(context) {
				var content =
					'<div style="background-color: hsla(180, 100%, 50%, 0.3); height: 18px; width: 18px; border: 1px solid hsl(180, 100%, 40%); border-radius: 12px; box-shadow: hsl(180, 100%, 50%) 0px 0px 3px;"></div>';
				var offset = new AMap.Pixel(-9, -9);
				context.marker.setContent(content);
				context.marker.setOffset(offset);
			},
			// 点击行
			handleCurrentChange(val) {
				this.divShow = false;
				this.plan1Edit(val.index, val.index);
			},
			// 将每行的索引放进行里
			tableRowClassName({row, rowIndex}) {
				row.index = rowIndex;
			},
			// 选择线路
			plan1Edit(index, index2) {
				if (this.routeMode == 3) {
					// 保存当前线路数据
					this.syListTow = this.syList[index2];
					this.planData = this.plans[index2];
					this.ifVehicle(0);
					// 车牌赋值
					this.numberPlate = this.syListTow.carInfo.numberPlate;
					// 显示左侧
					this.divShow = true;
					// 这个参数为路线的下标
					this.indexDate = index2;
					// 设置默认标记点
					this.radio = 0;
					this.plans.forEach((plan) => {
						plan.hide();
					});
					this.plans[index2].startEdit(function() {});
					this.plan1AddPoint(0);
				} else {
					// 保存当前线路数据
					this.syListTow = this.syList[index];
					this.planData = this.plans[index];
					this.ifVehicle(0);
					// 车牌赋值
					this.numberPlate = this.syListTow.carInfo.numberPlate;
					// 显示左侧
					this.divShow = true;
					// 这个参数为路线的下标
					this.indexDate = index;
					// 设置默认标记点
					this.radio = 0;
					this.plans.forEach((plan) => {
						plan.hide();
					});
					this.plans[index].startEdit(function() {});
					this.plan1AddPoint(0);
				}
			},
			// 计划点增加-获取当前点位
			plan1AddPoint(index) {
				if (index != this.planData.linePiece.routePoints.length - 1) {
					this.radio = index;
				}
				let point = this.planData.linePiece.routePoints[index];
				// 选中点-交互
				// if(this.routeMode != 3){
				// }
				if (point) {
					this.plans[this.indexDate].markerShowThree(point, index);
				}
			},
			// 把待选点添加到
			plan1AddPointTow(index) {
				let that = this;
				this.ifVehicle(1, index);
			},
			// 列表查询添加
			searchClick(index) {
				let point = this.freePoints[index];
				let that = this;
				// 车载 carCapacity
				let carCapacity = this.syListTow.carInfo.carCapacity;
				//  路线垃圾产生量
				var weightList = this.planData.linePiece.routePoints.filter((item) => {
					if (item.weight) {
						return item;
					}
				});
				this.weight = 0;
				weightList.forEach((item, index) => {
					this.weight += Number(item.weight);
				});
				// if (this.weight + Number(point.weight) > carCapacity) {
				//   that.$message({
				//     message: "预产量已超出当前车载，请进行车辆调整",
				//     type: "warning",
				//   });
				// } else {

				// }
				this.weight = this.weight + Number(point.weight);
				let a = this.planData.linePiece.routePoints.filter((item) => {
					if (item.unitName.indexOf(point.unitName) != -1) {
						return item;
					}
				});
				if (a.length != 0) {
					that.$message({
						message: "产生单位重复,请重新选择",
						type: "warning",
					});
					return;
				}
				point.newlyAdded = 1;
				this.plans[this.indexDate].addNewPoint(point, that.radio + 1);
				this.freePoints = "";
				this.handleSearch();
				this.fullscreenLoading = true;
				setTimeout(() => {
					this.fullscreenLoading = false;
				}, 1000);
			},
			// 计划点移除
			plan1DelPoint(index) {
				// 后面位移除单位下标
				this.fullscreenLoading = true;
				setTimeout(() => {
					this.fullscreenLoading = false;
				}, 1000);
				this.plans[this.indexDate].removePoint(index);
				this.ifVehicle(0);
			},
			gotodata(index, formNum) {
				this.plans[this.indexDate].getList(index, formNum);
			},
			edit(element) {
				let that = this;
				// 获取要编辑的文本内容
				var oldHtml = element.target.innerText;
				// 创建一个新的 input 输入框
				var newInput = document.createElement("input");
				// 为新的 input添加属性
				newInput.type = "text";
				newInput.value = oldHtml;
				newInput.style.width = "30px";
				// 清空当前元素的文本内容
				element.target.innerText = "";
				// 把新的 input 框 追加到当前元素节点中
				element.target.appendChild(newInput);
				// 设置选择文本的内容或设置光标位置（两个参数：start,end；start为开始位置，end为结束位置；如果开始位置和结束位置相同则就是光标位置）
				newInput.setSelectionRange(0, oldHtml.length);
				// 为新 input 框获取焦点
				newInput.focus();
				// 为新的 input 添加失去焦点事件
				newInput.onblur = function() {
					// 判断失去焦点时，input 框的值是否与原值相同，相同则表示没有修改，返回原值；不同则表示有改动，返回新值
					// element.target.innerText = this.value == oldHtml ? oldHtml : this.value;
					element.target.innerText = oldHtml;
					if (oldHtml != this.value) {
						let num = oldHtml;
						if(this.value == 1 || this.value == that.planData.linePiece.routePoints.length){
							that.$message({
								message: "起点和终点不可以改变顺序！",
								type: "warning",
							});
						}else{
							that.gotodata(num, this.value);
						}
					}
				};
			},
			// 保存
			plan1save() {
				let that = this;
				if (this.syListTow.carInfo.carCapacity != 0) {
					this.syListTow.planUnitList = this.planData.linePiece.routePoints;
					if (this.syListTow.planUnitList.length > 2) {
						let a = this.a;
						a.planId = this.syListTow.planId;
						if (this.vehicle) {
							a.carId = this.vehicle.id;
						} else {
							a.carId = this.syListTow.carInfo.id;
						}
						this.plans[this.indexDate].saveRoute(a, this.carFlag);
					} else {
						that.$message({
							message: "未添加产生单位,请添加",
							type: "warning",
						});
					}
				} else {
					that.$message({
						message: "执行车辆不能为空,请选择执行车辆",
						type: "warning",
					});
				}
			},
			//刷新
			backPlans() {
				//全部remove() 然后重新setdata
				this.divShow = false;
				setTimeout(() => {
					this.refFreePoints();
				}, 1000);
			},
			// 全部计划路线请求
			refresh() {
				let that = this;
				var a = this.a;
				that.$util._formPost(
					false,
					that,
					"",
					a,
					api.ctS_get_plan_list,
					function(_r) {
						if (_r.success) {
							if (_r.data) {
								if (_r.data.length != 0) {
									_r.data = _r.data.filter((item) => {
										if (
											item.carInfo &&
											// item.pathPoints &&
											item.planId &&
											item.planUnitList &&
											item.endPoint &&
											item.startPoint
										) {
											return item;
										}
									});
									// _r.data.length = []
									if (_r.data.length == 0) {
										that.refStartEnd();
										return;
									}
									_r.data.forEach((item) => {
										item.unassignedUnitList = that.freePointsList;
										const resmap = new Map();
										item.planUnitList = item.planUnitList.filter(
											(res) =>
											!resmap.has(res.unitName) && resmap.set(res.unitName, 1)
										);

										if (item.startPoint) {
											item.startPoint.unitName = item.startPoint.name;
											item.planUnitList.unshift(item.startPoint);
										}
										if (item.endPoint) {
											item.endPoint.unitName = item.endPoint.name;
											item.planUnitList.push(item.endPoint);
										}
									});
									that.syList = _r.data;
									that.tableData = _r.data;
									that.initMap();
								}
                else {
									// 起终点请求
									that.refStartEnd();
								}
							}
						}
					}
				);
				that.$req.post("", api.paramSetting, function(_r, _x) {
					if (_r.success == true) {
						let res = _r;
						that.routeMode = res.data.routeMode;
					}
				});
			},
			// 是否更换车辆判断
			ifVehicle(data, index) {
				let that = this;
				// 车载 carCapacity
				if (!this.syListTow) {
					return;
				}
				let carCapacity = this.syListTow.carInfo.carCapacity;

				// if(this.routeMode != 3){
				//   console.log(1)
				// }
				//  路线垃圾产生量
				var weightList = this.planData.linePiece.routePoints.filter((item) => {
					if (item.weight != null) {
						return item;
					}
				});
				this.weight = 0;
				weightList.forEach((item, index) => {
					this.weight += Number(item.weight);
				});

				let point = {
					weight: 0
				};
				if (index >= 0) {
					point = this.planData.linePiece.freePoints[index];
				}
				if (data) {
					// if (this.weight + Number(point.weight) > carCapacity) {
					//   that.$message({
					//     message: "预产量已超出当前车载，请进行车辆调整",
					//     type: "warning",
					//   });
					// } else {

					// }
					this.weight = this.weight + Number(point.weight);
					let a = this.planData.linePiece.routePoints.filter((item) => {
						if (item.unitName.indexOf(point.unitName) != -1) {
							return item;
						}
					});
					if (a.length != 0) {
						that.$message({
							message: "产生单位重复,请重新选择",
							type: "warning",
						});
						return;
					}
					if (this.radio != this.planData.linePiece.routePoints.length - 1) {
						point.newlyAdded = 1;
						this.plans[this.indexDate].addNewPoint(point, that.radio + 1);
						this.fullscreenLoading = true;
						setTimeout(() => {
							this.fullscreenLoading = false;
						}, 1000);
					} else {
						that.$message({
							message: "不能在处理单位后添加产生单位,请重新选择",
							type: "warning",
						});
					}
				}
			},
			// 可选车辆
			refreshTow() {
				let that = this;
				var a = this.a;
				that.$util._formPost(
					false,
					that,
					"",
					a,
					api.ctS_get_AL_CarInfo,
					function(_r) {
						if (_r.success) {
							_r.data = _r.data.filter((item) => {
								if (item.numberPlate && item.weight) {
									return item;
								}
							});
							that.vehicleList = _r.data;
							that.vehicleList.filter((item) => {
								if (item.weight > that.weight) {
									return item;
								}
							});
							that.dialogVisible = true;
						}
					}
				);
			},
			// 路线车辆表单关闭
			handleClose() {
				this.dialogVisible = false;
			},
			// 取消按钮
			cancel() {
				this.dialogVisible = false;
			},
			// 路线执行车辆提交
			Submit() {
				let that = this;
				let vehicle = {};
				if (this.numberPlateIndex.length != 0) {
					vehicle = this.vehicleList[this.numberPlateIndex];
					this.numberPlate = vehicle.numberPlate;
				} else {
					this.numberPlate = "";
					vehicle.id = "";
				}
				this.syListTow.carInfo.carCapacity = vehicle.weight;
				this.vehicle = vehicle;
				let vehicleForm = {
					planId: this.syListTow.planId,
					carId: vehicle.id,
				};
				if (this.carFlag) {
					this.carFlagId = vehicle.id;
					that.dialogVisible = false;
				} else {
					that.$util._formPost(
						false,
						that,
						"",
						vehicleForm,
						api.ctS_Rou_Updat,
						function(_r) {
							if (_r.success) {
								that.dialogVisible = false;
							}
						}
					);
				}
			},
			// 随机颜色
			getRandomColor() {
				let varcolor = Math.floor(Math.random() * 0xffffff).toString(16);
				if (varcolor.length == 6) {
					this.varcolor = "#" + varcolor;
				} else {
					this.getRandomColor();
				}
			},
			// 提示
			messageError(data) {
				this.$message.error(data);
			},
			// 新增部分
			addedPlan() {
				let that = this;
				this.numberPlate = ""; // 路线车辆名称
				this.numberPlateIndex = ""; // 当前执行车辆下标
				let data = {
					carInfo: {
						carCapacity: 0,
						numberPlate: "",
						planId: ""
					},
					planUnitList: that.startEndPoint,
					planId: "",
					pathPoints: "",
					unassignedUnitList: that.freePointsList,
				};
				this.syList.push(data);
				this.initMap(1);
			},
			// 新增起终点请求
			refStartEnd() {
				let that = this;
				this.carFlag = true;
				that.startEndPoint = [];
				that.$util._formPost(
					false,
					that,
					"",
					"",
					api.ctS_get_tartAndEnd,
					function(_r) {
						if (_r.success) {
							if (_r.data) {
								var res = _r.data;
								let data = {
									ctLat: res.ctLat,
									ctLon: res.ctLon,
									ctUnitId: res.ctUnitId,
									unitId: res.ctUnitId,
									lon: res.ctLon,
									lat: res.ctLat,
									unitName: res.ctName,
								};

								if (res.isHandleUnit != 0) {
									that.startEndPoint.push(data);
									that.startEndPoint.push(data);
									that.addedPlan();
								} else {
									// 起终点不一样，进行
									that.EndPoint = res.list;
									that.EndPoint.forEach((item) => {
										item.unitId = item.huId;
										item.lon = item.huLon;
										item.lat = item.huLat;
										item.unitName = item.huName;
									});
									that.startEndPoint.push(data);
									that.startEndPointShow = true;
								}
							}
						}
					}
				);
			},
			// 待选点请求
			refFreePoints() {
				let that = this;
				var a = this.a;
				that.divShow = false;
				that.freePointsList = [];
				var param = {
					param: JSON.stringify(a),
				};
				that.$util._formPost(
					false,
					that,
					"",
					param,
					api.ctS_get_UnassignedUnitList,
					function(_r) {
						if (_r.success) {
							let res = _r.data;
							// 根据
							const resmap = new Map();
							res = res.filter(
								(res) => !resmap.has(res.unitName) && resmap.set(res.unitName, 1)
							);
							res = res.filter((item) => {
								if (item.lat && item.lon) {
									return item;
								}
							});
							res = res.filter((item) => {
								if (item.lat.indexOf(".") != -1 && item.lon.indexOf(".") != -1) {
									return item;
								}
							});
							that.freePointsList = res;
							that.refresh();
						}
					}
				);
			},
			// 终点选择关闭
			handlestartEnd() {},
			// 终点选择确认
			startEndSubmit(formName) {
				let that = this;
				this.startEndIndex = this.startEndForm.startEndIndex;
				this.$refs[formName].validate((valid) => {
					if (valid) {
						this.startEndPointShow = false;
						this.startEndPoint.push(this.EndPoint[this.startEndIndex]);
						// 进入新增状态
						this.addedPlan();
					} else {
						return false;
					}
				});
			},
			deleteData(row) {
				// console.log(row)
				let that = this;
				this.$confirm("是否删除该数据, 是否继续?", "提示", {
					confirmButtonText: "确定",
					cancelButtonText: "取消",
					type: "warning",
				}).then(() => {
					let param = new FormData();
					param.append("id", row.planId);
					that.$req.post(param, api.ctS_ctPlan_delete, function(_r) {
						that.$util._notify.success("删除成功");
						that.refresh();
						that.divShow = false;
					});
				});
			}
		},
	};
</script>

<style lang="scss" scoped>
	// 地图部分样式
	.relativeContainer {
		position: relative;

		// 计划时间
		.planDate {
			position: absolute;
			top: -35px;
			left: 20px;
			font-size: 20px;
			z-index: 999;
		}

		.map {
			width: 100%;
			height: 140%;
		}

		.search {
			position: absolute;
			top: 10px;
			right: 10px;
			// width: 285px;
			z-index: 1;
			// input {
			//   width: 180px;
			//   border: 1px solid #ccc;
			//   line-height: 20px;
			//   padding: 5px;
			//   outline: none;
			// }
			// button {
			//   line-height: 26px;
			//   background: #fff;
			//   border: 1px solid #ccc;
			//   width: 50px;
			//   text-align: center;
			// }
		}
	}

	// 左侧路线编辑
	.divShow {
		border: none;
		width: 320px;
		height: 125%;
		background-color: #fff;
		position: absolute;
		top: 26px;
		left: 20px;
		filter: progid:DXImageTransform.Microsoft.Shadow(color=#909090, direction=120, strength=4);
		-moz-box-shadow: 2px 2px 10px #909090;
		-webkit-box-shadow: 2px 2px 10px #909090;
		box-shadow: 2px 2px 10px #909090;

		h1 {
			position: relative;
			width: 100%;
			height: 50px;
			background: rgba(0, 100, 222, 1);
			opacity: 0.9;
			border-radius: 6px 6px 0px 0px;
			font-size: 16px;
			font-family: PingFang SC;
			font-weight: 400;
			color: rgba(255, 255, 255, 1);
			line-height: 50px;

			em {
				display: inline-block;
				width: 24px;
				height: 24px;
				font-size: 24px;
				position: absolute;
				left: 13px;
				top: 13px;
			}

			i {
				display: inline-block;
				width: 16px;
				height: 16px;
				font-size: 16px;
				position: absolute;
				right: 14px;
				top: 17px;
			}
		}

		h2 {
			margin: 18px 0;
			padding: 0 18px;
			width: 100%;
			height: 14px;
			font-size: 15px;
			font-family: PingFang SC;
			font-weight: 400;
			color: rgba(37, 43, 58, 1);
			line-height: 24px;
			display: flex;
			justify-content: space-between;

			i {
				font-style: normal;
				color: red;
			}

			span {
				display: inline-block;
				height: 100%;
			}
		}

		hr {
			width: 90%;
			height: 1px;
			border: 2px solid rgba(234, 239, 244, 1);
			margin: auto;
		}

		.editDiv {
			width: 100%;
			height: 67%;
			padding: 15px 18px 0;
			overflow-y: auto;

			// margin-bottom: 20px;
			div {
				position: relative;
				width: 100%;
				height: 30px;
				margin: 10px 0;
				display: flex;
				align-content: center;
				justify-content: space-around;

				span {
					display: inline-block;
					width: 18px;
					height: 18px;
					background: rgba(22, 127, 255, 1);
					border-radius: 9px;
					font-size: 11px;
					font-family: PingFang SC;
					font-weight: 500;
					color: rgba(255, 255, 255, 1);
				}

				em {
					font-style: normal;
					margin-left: 11px;
					width: 152px;
					height: 24px;
					border-radius: 3px;
					font-size: 12px;
					font-family: PingFang SC;
					font-weight: 400;
					color: rgba(37, 43, 58, 1);
					line-height: 24px;
					border: none;
					overflow: hidden;
					white-space: nowrap;
				}

				input:focus {
					background: rgba(234, 239, 244, 1);
					border-radius: 3px;
					border: none;
				}

				p {
					display: flex;
					padding-top: 5px;
					justify-content: space-between;
					line-height: 30px;
					width: 80px;
				}
			}
		}

		// 搜索
		.searchInput {
			width: 314px;
			position: absolute;
			top: 0px;
			left: 330px;
			z-index: 999;
			padding-bottom: 10px;

			.inputData {
				width: 100%;
				// height: 30px;
				filter: progid:DXImageTransform.Microsoft.Shadow(color=#909090, direction=120, strength=4);
				-moz-box-shadow: 2px 2px 10px #909090;
				-webkit-box-shadow: 2px 2px 10px #909090;
				box-shadow: 2px 2px 10px #909090;
				margin-bottom: 30px;
			}

			.divDate {
				position: absolute;
				width: 100%;
				max-height: 300px;
				padding: 10px 0;
				overflow-y: auto;
				background-color: #fff;
				filter: progid:DXImageTransform.Microsoft.Shadow(color=#909090, direction=120, strength=4);
				-moz-box-shadow: 2px 2px 10px #909090;
				-webkit-box-shadow: 2px 2px 10px #909090;
				box-shadow: 2px 2px 10px #909090;
				display: flex;
				flex-direction: column;
				flex: 1 1 auto;

				div {
					width: 100%;
					height: 30px;
					background-color: #fff;
					margin: 5px 0;
					border-bottom: 1px solid #eee;
					display: flex;
					justify-content: space-between;

					p {
						width: 100%;
						height: 30px;
						line-height: 30px;
						padding-left: 10px;
						background-color: #fff;
						color: black;
						font-size: 12px;

						span {
							display: inline-block;
							width: 20%;
							height: 30px;
							background-color: #fff;
							color: black;
						}
					}

					i {
						display: inline-block;
						height: 30px;
						width: 30px;
						color: #fff;
						background-color: #167fff;
						line-height: 30px;
						border-radius: 2px;
						font-size: 16px;
						margin-right: 10px;
					}
				}
			}
		}

		.btn {
			position: absolute;
			bottom: 20px;
			left: 38%;
			margin: auto;
		}
	}

	// 车辆选择表单样式
	.vForm {
		margin-bottom: 20px;

		p {
			display: inline-block;
			margin-right: 10px;
			font-size: 14px;
		}
	}

	.iconFrom {
		width: 120px;
		height: 32px;
		line-height: 32px;
		background: rgba(255, 255, 255, 1);
		border-radius: 8px 8px 0px 0px;
		font-size: 15px;
		font-family: PingFang SC;
		font-weight: 500;
		color: rgba(22, 127, 255, 1);
		position: fixed;
		right: 13%;
		bottom: 20px;
		display: flex;
		justify-content: space-around;
		filter: progid:DXImageTransform.Microsoft.Shadow(color=#909090, direction=120, strength=4);
		-moz-box-shadow: 2px 2px 10px #909090;
		-webkit-box-shadow: 2px 2px 10px #909090;
		box-shadow: 2px 2px 10px #909090;
	}

	.iconFromDiv {
		position: fixed;
		right: 10%;
		bottom: 0;
		width: 40%;
		height: 20px;
		background-color: #fff;
		border-radius: 8px 8px 0px 0px;
		filter: progid:DXImageTransform.Microsoft.Shadow(color=#909090, direction=120, strength=4);
		-moz-box-shadow: 2px 2px 10px #909090;
		-webkit-box-shadow: 2px 2px 10px #909090;
		box-shadow: 2px 2px 10px #909090;
	}

	.collectShow-enter-active,
	.collectShow-leave-active {
		transition: all 1.5s;
	}

	.collectShow-enter,
	.collectShow-leave-to {
		opacity: 0;
		transform: translateY(400px);
	}

	// 底部数据显示
	.collect {
		width: 40%;
		position: fixed;
		right: 10%;
		bottom: 0;
		background-color: #fff;
		z-index: 999;
		border-radius: 8px 8px 0px 0px;
		filter: progid:DXImageTransform.Microsoft.Shadow(color=#909090, direction=120, strength=4);
		-mozbox-shadow: 2px 2px 10px #909090;
		-webkit-box-shadow: 2px 2px 10px #909090;
		box-shadow: 2px 2px 10px #909090;

		.btn {
			width: 120px;
			height: 32px;
			line-height: 32px;
			background: rgba(255, 255, 255, 1);
			border-radius: 8px 8px 0px 0px;
			font-size: 15px;
			font-family: PingFang SC;
			font-weight: 500;
			color: rgba(22, 127, 255, 1);
			position: absolute;
			top: -32px;
			right: 50px;
			display: flex;
			justify-content: space-around;
		}

		.block {
			background-color: #fff;
			margin: 0 0;
			padding: 2px 0;
			height: 35px;
		}

		.vehicle {
			// width: 32%;
			position: absolute;
			top: 12px;
			right: 30px;
			font-size: 13px;
			font-family: PingFang SC;
			font-weight: 300;
			display: flex;
			justify-content: space-between;

			span {
				margin: 0 10px;
			}
		}
	}

	// 新增编辑点位鼠标滑过划出部分
	.mouseoverDiv {
		position: relative;
		height: 38px;
		line-height: 38px;

		span {
			display: inline-block;
		}

		.span1 {
			padding: 0 3px;
			font-size: 12px;
			font-family: PingFang SC;
			font-weight: 400;
			color: rgba(37, 43, 58, 1);
			height: 100%;
		}

		.span2 {
			font-size: 12px;
			font-family: PingFang SC;
			font-weight: 400;
			background-color: #167fff;
			color: #fff;
			width: 38px;
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/map/GDmap.vue